import React from 'react'
import {useLocation } from 'react-router-dom'

const Blog = () => {

    const location=useLocation();
   
  return (
    <div>
        <h1>{location.state.title} Info</h1>
        <p>{location.state.body.slice(0, 296)}</p>
        <p>{location.state.body.slice(297, 6000)}</p>
    </div>
  )
}

export default Blog